'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _UIAbstractPopup = require('./UIAbstractPopup');

var _UIAbstractPopup2 = _interopRequireDefault(_UIAbstractPopup);

var _UIPopoverContent = require('./UIPopoverContent');

var _UIPopoverContent2 = _interopRequireDefault(_UIPopoverContent);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _ModalTransitionContext = require('../context/ModalTransitionContext');

var _Functions = require('../core/Functions');

var _EventHandlers = require('../core/EventHandlers');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Placement = require('./utils/Placement');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getArrowSize = function getArrowSize(arrowSize, use) {
  if (arrowSize != null) return arrowSize;
  if (use === 'tooltip' || use === 'tooltip-danger') return 'small';
  return 'medium';
};

var getPlacement = function getPlacement(placementProp, placementState) {
  return placementState || placementProp;
};

var getIsVisible = function getIsVisible(content, open, modalTransitionContext) {
  return content != null && open && !modalTransitionContext.transitioning;
};

var UIPopover = _react2.default.createClass({
  displayName: 'UIPopover',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: _extends({}, _UIPopoverContent2.default.propTypes, {
    addTargetClasses: _react.PropTypes.bool,
    arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)),
    autoPlacement: _UIAbstractPopup2.default.propTypes.autoPlacement,
    children: _react.PropTypes.element,
    closeOnOutsideClick: _react.PropTypes.bool.isRequired,
    content: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
      header: _react.PropTypes.node,
      body: _react.PropTypes.node,
      footer: _react.PropTypes.node
    })]).isRequired,
    onFocusLeave: _react.PropTypes.func,
    onChangePlacement: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    pinToConstraint: _UIAbstractPopup2.default.propTypes.pinToConstraint,
    pinToOutOfBoundsTarget: _UIAbstractPopup2.default.propTypes.pinToOutOfBoundsTarget,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    target: _react.PropTypes.instanceOf(HTMLElement),
    targetAttachment: _react.PropTypes.string.isRequired,
    modalTransitionContext: _ModalTransitionContext.modalTransitionContextPropType.isRequired,
    zIndex: _react.PropTypes.number.isRequired,
    _distanceAdjustment: _react.PropTypes.number,
    _insetAdjustment: _react.PropTypes.number,
    _bodyElement: _react.PropTypes.instanceOf(HTMLElement),
    _useMutationObserver: _react.PropTypes.bool.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIPopoverContent2.default.defaultProps, {
      autoPlacement: true,
      closeOnOutsideClick: true,
      _distanceAdjustment: 0,
      _insetAdjustment: 0,
      open: false,
      pinToConstraint: ['top', 'bottom'],
      pinToOutOfBoundsTarget: false,
      placement: 'top',
      targetAttachment: 'auto',
      zIndex: _UIAbstractPopup2.default.defaultProps.zIndex,
      _useMutationObserver: false
    });
  },
  getInitialState: function getInitialState() {
    var _props = this.props,
        animateOnToggle = _props.animateOnToggle,
        content = _props.content,
        open = _props.open,
        modalTransitionContext = _props.modalTransitionContext;

    var isVisible = getIsVisible(content, open, modalTransitionContext);
    return {
      closeComplete: animateOnToggle ? !open : true,
      hasRendered: false,
      isVisible: isVisible,
      placement: null
    };
  },
  componentDidMount: function componentDidMount() {
    this._isMounted = true;
    /* eslint-disable react/no-did-mount-set-state */
    this.setState({
      hasRendered: true
    });
    /* eslint-enable react/no-did-mount-set-state */

    if (this.state.isVisible) window.addEventListener('click', this.handleWindowClick);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // If the placement prop is reset, clear our internal override.
    if (nextProps.placement !== this.props.placement) {
      this.setState({ placement: null });
    }

    // Determine whether the popover should be displayed.
    var isVisible = getIsVisible(nextProps.content, nextProps.open, nextProps.modalTransitionContext);
    if (isVisible !== this.state.isVisible) {
      this.setState({ isVisible: isVisible });
      if (!isVisible) {
        this.setState({ closeComplete: false });
      }
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    var isVisible = this.state.isVisible;

    if (isVisible) {
      window.addEventListener('click', this.handleWindowClick);
    } else {
      window.removeEventListener('click', this.handleWindowClick);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('click', this.handleWindowClick);
    clearTimeout(this._leaveTransitionTimeout);
  },
  handleWindowClick: function handleWindowClick(evt) {
    var _props2 = this.props,
        closeOnOutsideClick = _props2.closeOnOutsideClick,
        onOpenChange = _props2.onOpenChange,
        target = _props2.target;

    if (!closeOnOutsideClick || !this._isMounted) return;

    var clickTarget = evt.target;
    var tetherTarget = target || (0, _reactDom.findDOMNode)(this._popup);
    var contentEl = (0, _reactDom.findDOMNode)(this._content);

    // Ignore the click if it's within our Tether target
    if (tetherTarget && tetherTarget.contains(clickTarget)) return;

    // Ignore the click if it's within our popover container
    if (contentEl && (0, _EventHandlers.isClickWithinContainer)(evt, contentEl)) return;

    // Otherwise, trigger close
    onOpenChange((0, _SyntheticEvent2.default)(false));
  },
  handleTetherUpdate: function handleTetherUpdate(event) {
    // Adjust our placement state to reflect Tether's response to a constraint
    var _props3 = this.props,
        autoPlacement = _props3.autoPlacement,
        onChangePlacement = _props3.onChangePlacement,
        placementProp = _props3.placement;
    var placementState = this.state.placement;

    var oldPlacement = getPlacement(placementProp, placementState);

    var newPlacementVert = autoPlacement === 'horiz' ? (0, _Placement.getVertPart)(oldPlacement) : event.targetAttachment.top;
    var newPlacementHoriz = autoPlacement === 'vert' ? (0, _Placement.getHorizPart)(oldPlacement) : event.targetAttachment.left;

    if (!newPlacementVert || !newPlacementHoriz) {
      // This indicates pinning, which we don't need to respond to
      return;
    }

    var newPlacement = null;
    if (newPlacementVert === 'center' || newPlacementVert === 'middle') {
      newPlacement = newPlacementHoriz;
    } else if (newPlacementHoriz === 'center' || newPlacementHoriz === 'middle') {
      // #1942
      newPlacement = newPlacementVert;
    } else {
      newPlacement = newPlacementVert + ' ' + newPlacementHoriz;
    }

    if (this.state.placement !== newPlacement) {
      this.setState({
        placement: newPlacement
      });
      (0, _Functions.callIfPossible)(onChangePlacement, { newPlacement: newPlacement });
    }
  },
  handleCloseComplete: function handleCloseComplete() {
    (0, _Functions.callIfPossible)(this.props.onCloseComplete);
    if (this._isMounted) {
      this.setState({ closeComplete: true });
    }
  },
  reposition: function reposition() {
    if (this._popup) {
      this._popup.repositionTether();
    }
  },
  contentRefCallback: function contentRefCallback(ref) {
    this._content = ref;
  },
  popupRefCallback: function popupRefCallback(ref) {
    this._popup = ref;
  },
  render: function render() {
    var _props4 = this.props,
        addTargetClasses = _props4.addTargetClasses,
        animateOnMount = _props4.animateOnMount,
        animateOnToggle = _props4.animateOnToggle,
        arrowColor = _props4.arrowColor,
        arrowSize = _props4.arrowSize,
        autoPlacement = _props4.autoPlacement,
        children = _props4.children,
        className = _props4.className,
        __closeOnOutsideClick = _props4.closeOnOutsideClick,
        content = _props4.content,
        id = _props4.id,
        onFocusLeave = _props4.onFocusLeave,
        __onChangePlacement = _props4.onChangePlacement,
        __onOpenChange = _props4.onOpenChange,
        __onCloseComplete = _props4.onCloseComplete,
        __open = _props4.open,
        pinToConstraint = _props4.pinToConstraint,
        pinToOutOfBoundsTarget = _props4.pinToOutOfBoundsTarget,
        placementProp = _props4.placement,
        style = _props4.style,
        target = _props4.target,
        targetAttachment = _props4.targetAttachment,
        __modalTransitionContext = _props4.modalTransitionContext,
        use = _props4.use,
        width = _props4.width,
        zIndex = _props4.zIndex,
        _bodyElement = _props4._bodyElement,
        _distanceAdjustment = _props4._distanceAdjustment,
        _insetAdjustment = _props4._insetAdjustment,
        _useMutationObserver = _props4._useMutationObserver,
        rest = _objectWithoutProperties(_props4, ['addTargetClasses', 'animateOnMount', 'animateOnToggle', 'arrowColor', 'arrowSize', 'autoPlacement', 'children', 'className', 'closeOnOutsideClick', 'content', 'id', 'onFocusLeave', 'onChangePlacement', 'onOpenChange', 'onCloseComplete', 'open', 'pinToConstraint', 'pinToOutOfBoundsTarget', 'placement', 'style', 'target', 'targetAttachment', 'modalTransitionContext', 'use', 'width', 'zIndex', '_bodyElement', '_distanceAdjustment', '_insetAdjustment', '_useMutationObserver']);

    var _state = this.state,
        closeComplete = _state.closeComplete,
        hasRendered = _state.hasRendered,
        isVisible = _state.isVisible,
        placementState = _state.placement;


    var computedArrowSize = getArrowSize(arrowSize, use);
    var computedArrowParams = _UIPopoverArrow2.default.ARROW_SIZES[computedArrowSize];
    var computedPlacement = getPlacement(placementProp, placementState);

    var renderedContent = _react2.default.createElement(_UIPopoverContent2.default, _extends({}, rest, {
      animateOnMount: animateOnMount,
      animateOnToggle: animateOnToggle,
      hasRendered: hasRendered,
      arrowColor: arrowColor,
      arrowSize: computedArrowSize,
      className: className,
      content: content,
      'data-component-name': 'UIPopover',
      id: id,
      onCloseComplete: this.handleCloseComplete,
      open: isVisible,
      placement: computedPlacement,
      ref: this.contentRefCallback,
      style: style,
      use: use,
      width: width
    }));

    return _react2.default.createElement(
      _UIAbstractPopup2.default,
      {
        addTargetClasses: addTargetClasses,
        autoPlacement: autoPlacement,
        bodyElement: _bodyElement,
        center: computedArrowSize !== 'none',
        content: renderedContent,
        distance: computedArrowParams.distance + _distanceAdjustment,
        inset: computedArrowParams.inset + _insetAdjustment,
        onFocusLeave: onFocusLeave,
        onTetherUpdate: this.handleTetherUpdate,
        open: isVisible || !closeComplete,
        pinToConstraint: pinToConstraint,
        pinToOutOfBoundsTarget: pinToOutOfBoundsTarget,
        placement: computedPlacement,
        ref: this.popupRefCallback,
        target: target,
        targetAttachment: targetAttachment,
        zIndex: zIndex,
        _useMutationObserver: _useMutationObserver
      },
      children
    );
  }
});

exports.default = (0, _ModalTransitionContext.ConsumesModalTransitionContext)((0, _Controllable2.default)(UIPopover, ['open']));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/tooltip/UIPopover.js
// module id = 85
// module chunks = 0